export const MENU_ENTRIES = {
  scope: 'scope',
  keyTermsUsed: 'key-terms-used',
  prerequisites: 'prerequisites',
  apiKey: 'api-key',
  apiKeyGettingAccess: 'api-key.getting-access',
  overviewOfDataUploadingProcess: 'overview-of-recall-data-uploading-process',
  creatingRecallInXmlFormat: 'creatingRecallInXmlFormat',
  creatingRecallInXmlFormatExamples: 'creatingRecallInXmlFormat.examples',
  creatingRecallInXmlFormatExamplesNewRecall: 'creatingRecallInXmlFormat.examples.new-recall',
  creatingRecallInXmlFormatExamplesUpdateRecall: 'creatingRecallInXmlFormat.examples.update-recall',
  creatingRecallInXmlFormatExamplesDeleteRecall: 'creatingRecallInXmlFormat.examples.delete-recall',
  creatingRecallInXmlFormatEmptyStructures: 'creatingRecallInXmlFormat.empty-structures',
  creatingRecallInXmlFormatEmptyStructuresNewRecall: 'creatingRecallInXmlFormat.empty-structures.new-recall',
  creatingRecallInXmlFormatEmptyStructuresUpdateRecall: 'creatingRecallInXmlFormat.empty-structures.update-recall',
  creatingRecallInXmlFormatEmptyStructuresDeleteRecall: 'creatingRecallInXmlFormat.empty-structures.delete-recall',
  xmlValidation: 'xml-validation',
  xmlValidationFiles: 'xml-validation.files',
  xmlValidationSteps: 'xml-validation.steps',
  ensureXmlAndImagesInOneFolder: 'ensure-xml-and-images',
  creatingZipFile: 'creating-zip-file',
  creatingZipFileZipCompression: 'creating-zip-file.zip-compression',
  uploadingZipToPortal: 'zip-upload',
  uploadingZipToPortalManualProcess: 'zip-upload.manual',
  htmlEncoding: 'html-encoding',
  fieldsDescription: 'fields-description',
  fieldsDescriptionRecall: 'fields-description.recall',
  fieldsDescriptionEditType: 'fields-description.edit-type',
  fieldsDescriptionId: 'fields-description.id',
  fieldsDescriptionCountryId: 'fields-description.country-id',
  fieldsDescriptionLang: 'fields-description.lang',
  fieldsDescriptionManufacturer: 'fields-description.manufacturer',
  fieldsDescriptionManufacturerCountryId: 'fields-description.manufacturer-country-id',
  fieldsDescriptionProductType: 'fields-description.product-type',
  fieldsDescriptionProductName: 'fields-description.product-name',
  fieldsDescriptionProductDesc: 'fields-description.product-desc',
  fieldsDescriptionProductCode: 'fields-description.product-code',
  fieldsDescriptionProductModelNo: 'fields-description.product-model-no',
  fieldsDescriptionHazard: 'fields-description.hazard',
  fieldsDescriptionInjuries: 'fields-description.injuries',
  fieldsDescriptionAction: 'fields-description.action',
  fieldsDescriptionUnits: 'fields-description.units',
  fieldsDescriptionURL: 'fields-description.url',
  fieldsDescriptionDate: 'fields-description.date',
  fieldsDescriptionDistributorName: 'fields-description.distributorname',
  fieldsDescriptionDistributorWebsite: 'fields-description.distributorwebsite',
  fieldsDescriptionGTIN: 'fields-description.gtin',
  fieldsDescriptionGTINProductType: 'fields-description.gtin-product-type',
  fieldsDescriptionGTINDesc: 'fields-description.gtin-desc',
  fieldsDescriptionHTS: 'fields-description.hts',
  fieldsDescriptionHTSProductType: 'fields-description.hts-product-type',
  fieldsDescriptionHTSDesc: 'fields-description.hts-desc',
  fieldsDescriptionImage: 'fields-description.image',
  fieldsDescriptionManufacturerWebsite: 'fields-description.manufacturer-website',
  fieldsDescriptionSeriousRisk: 'fields-description.serious-risk',
  productCodes: 'product-codes',
  productCodesDefinition: 'product-codes.definition',
  productCodesValues: 'product-codes.values',
  productCodesXmlStructure: 'product-codes.xml-structure',
  productCodesFieldProductCode: 'product-codes.field-product-code',
  productCodesSubFieldPublication: 'product-codes.subfield-publication',
  productCodesSubFieldSegment: 'product-codes.subfield-segment',
  productCodesSubFieldFamily: 'product-codes.subfield-family',
  productCodesSubFieldClass: 'product-codes.subfield-class',
  productCodesSubFieldBrick: 'product-codes.subfield-brick',
  productCodesSubFieldAttrs: 'product-codes.subfield-attrs',
  productCodesXmlExamples: 'product-codes-xml-examples',
  gpcMoreInformation: 'gpc-more-information',
  complexFieldImages: 'complex-field-images',
  complexFieldImagesFilename: 'complex-field-images.filename',
  complexFieldImagesMediaType: 'complex-field-images.mediatype',
  complexFieldImagesAltText: 'complex-field-images.alttext',
  apiTechnicalDetails: 'api-technical-details',
};


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/constants.js